import React from 'react';

const CommentIcon = ({ size = 16 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
            <path d="M14.6667 11.3333C14.6667 11.687 14.5262 12.0261 14.2761 12.2761C14.0261 12.5262 13.687 12.6667 13.3333 12.6667H4.552C4.19841 12.6667 3.85932 12.8073 3.60933 13.0573L2.14133 14.5253C2.07514 14.5915 1.9908 14.6366 1.89899 14.6548C1.80718 14.6731 1.71202 14.6637 1.62554 14.6279C1.53906 14.5921 1.46513 14.5314 1.41312 14.4536C1.36111 14.3758 1.33335 14.2843 1.33333 14.1907V3.33333C1.33333 2.97971 1.47381 2.64057 1.72386 2.39052C1.97391 2.14048 2.31304 2 2.66667 2H13.3333C13.687 2 14.0261 2.14048 14.2761 2.39052C14.5262 2.64057 14.6667 2.97971 14.6667 3.33333V11.3333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default CommentIcon;
